import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant,{Toast ,Lazyload , Tab, Tabs }  from 'vant'
import store from './store'
import Less from 'less'
import 'vant/lib/index.css' //vant默认样式引入
import '@vant/touch-emulator';//在桌面端使用
import '@/assets/css/iconfont.css' //阿里图标库引入
import '@/assets/css/common.css' //公共样式引入
import 'lib-flexible'
import { get, post, delet, postform } from "./http/index";
import '@/assets/css/index.less' //页面样式less
import { formatDate  } from '@/assets/js/date.js';// 时间倒计时
import  WXConfig  from '@/assets/js/wxjsapi';
/*import AlloyFinger from 'alloyfinger'//放大缩小
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue' //放大缩小*/


import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueAliplayerV2 from 'vue-aliplayer-v2';

// import style (>= Swiper 6.x)
// import 'swiper/swiper-bundle.css'

// import style (<= Swiper 5.x)
import 'swiper/css/swiper.css'
import '@vant/touch-emulator';


Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$postform = postform;
Vue.prototype.$delet = delet;
Vue.config.productionTip = false;
Vue.prototype.$WXConfig = WXConfig;
Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(Toast);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Less);
Vue.use(WXConfig);

Vue.use(VueAliplayerV2);

/*Vconsole调试工具*/
/*import Vconsole from 'vconsole'
  let vConsole = new Vconsole()
  Vue.use(vConsole)*/

/*
//放大缩小
Vue.use(AlloyFingerPlugin,{
  AlloyFinger
})
*/

Vue.use( VueAwesomeSwiper, /* { default global options } */ )

// 根据路由设置标题
router.beforeEach((to, from, next) => {
  /*路由发生改变修改页面的title */
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next();
})

new Vue({
  router,
  store,  //store:store 和router一样，将我们创建的Vuex实例挂载到这个vue实例中
  render: h => h(App)
}).$mount('#app')
